import { render, staticRenderFns } from "./card-order.vue?vue&type=template&id=09805c1a&scoped=true"
import script from "./card-order.vue?vue&type=script&lang=js"
export * from "./card-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09805c1a",
  null
  
)

export default component.exports